export const typography = {
    primary:"16px",
    secondary:"13px",
    large:"22px",
    x_large:"25px",
    xx_large:"35px",
    xxx_large:"75px",
}